import { createFileRoute } from "@tanstack/react-router";
import SelfLcdCondition from "@/features/assessments/pages/self-lcd-condition/SelfLcdCondition";

export const Route = createFileRoute("/$locale/$partner/_cosmetic/self-lcd-condition")({
	component: SelfLcdCondition,
});
